"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3241],{

/***/ 95197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7414);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19236);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* eslint-disable jsx-a11y/anchor-is-valid */ 




function TitleCus(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, {
        sx: function(theme) {
            return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                margin: "70px 0 20px"
            }, theme.fn.smallerThan("md"), {
                margin: "30px 15px"
            });
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .Title */ .D, {
            order: 2,
            size: "h2",
            align: "center",
            w: "100#",
            sx: function(theme) {
                return {
                    transition: "0.3s",
                    color: theme.colors.second[3],
                    "&:hover": {
                        color: theme.colors.second[3]
                    }
                };
            },
            children: children
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (TitleCus);


/***/ }),

/***/ 74043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CheckBoxPaymentMethod; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _setup_cartProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27104);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39954);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56817);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62679);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7414);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34736);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(66137);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9094);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(95117);
/* harmony import */ var _react_icons_all_files_fa_FaCircle__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97432);
/* harmony import */ var _react_icons_all_files_fi_FiCircle__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44164);
/* harmony import */ var _react_icons_all_files_fi_FiCreditCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43516);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);









function ImageMethod(param) {
    var item = param.item;
    return (item === null || item === void 0 ? void 0 : item.image) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .Image */ .E, {
        src: item === null || item === void 0 ? void 0 : item.image
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fi_FiCreditCard__WEBPACK_IMPORTED_MODULE_4__/* .FiCreditCard */ .X, {});
}
var useStyles = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .createStyles */ .k)(function(theme) {
    return {
        container: {
            flexDirection: "column",
            borderColor: "rgba(0,0,0,0.15)",
            borderWidth: 1,
            borderStyle: "solid",
            borderRadius: "0.5rem"
        },
        button: {
            borderBottom: 1,
            borderColor: "rgba(0,0,0,0.15)",
            borderStyle: "solid",
            padding: 10,
            width: "100%"
        },
        colorChecked: {
            color: theme.colors.main[5]
        }
    };
});
function CheckBoxPaymentMethod(param) {
    var defaultCheck = param.defaultCheck, keyItem = param.keyItem;
    var classes = useStyles().classes;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_setup_cartProvider__WEBPACK_IMPORTED_MODULE_1__/* .CartContext */ .A9), listPaymentMethod = ref.listPaymentMethod, setPaymentSelected = ref.setPaymentSelected;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, keyItem, "")), checkedItem = ref1[0], setCheckedItem = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (defaultCheck && (listPaymentMethod === null || listPaymentMethod === void 0 ? void 0 : listPaymentMethod.length) > 0 && !checkedItem[keyItem]) {
            setPaymentSelected(listPaymentMethod[0]);
            setCheckedItem(listPaymentMethod[0]);
        }
    }, [
        defaultCheck,
        listPaymentMethod
    ]);
    var onChecked = function(item) {
        setPaymentSelected(item);
        setCheckedItem(item);
    };
    // const { theme } = useTheme();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Grid */ .r, {
        className: classes.container,
        children: listPaymentMethod === null || listPaymentMethod === void 0 ? void 0 : listPaymentMethod.map(function(item, index) {
            var ref, ref1, ref2;
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .x, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .UnstyledButton */ .k, {
                        className: classes.button,
                        sx: (listPaymentMethod === null || listPaymentMethod === void 0 ? void 0 : listPaymentMethod.length) === index + 1 && {
                            borderBottom: 0
                        },
                        onClick: function() {
                            return onChecked(item);
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Group */ .Z, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .x, {
                                    children: checkedItem[keyItem] === item[keyItem] ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fa_FaCircle__WEBPACK_IMPORTED_MODULE_11__/* .FaCircle */ .g, {
                                        className: classes.colorChecked
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fi_FiCircle__WEBPACK_IMPORTED_MODULE_12__/* .FiCircle */ .Q, {})
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_13__/* .Center */ .M, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageMethod, {
                                            item: true
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                                            sx: {
                                                paddingLeft: 10
                                            },
                                            children: item === null || item === void 0 ? void 0 : item.ten
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    (item === null || item === void 0 ? void 0 : item.payment_service) === "bank" && checkedItem[keyItem] === item[keyItem] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .x, {
                        sx: {
                            padding: 10
                        },
                        style: {
                            borderBottom: 1,
                            borderBottomColor: "rgba(0,0,0,0.15)",
                            // borderStyle: "solid",
                            borderBottomStyle: "solid"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                                align: "center",
                                sx: {
                                    marginBottom: 10
                                },
                                children: "Chuyển khoản v\xe0o t\xe0i khoản của ZeMor Coffee"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                                align: "center",
                                sx: {
                                    marginBottom: 10
                                },
                                children: [
                                    "T\xean t\xe0i khoản: ",
                                    item === null || item === void 0 ? void 0 : (ref = item.bank_configs) === null || ref === void 0 ? void 0 : (ref1 = ref.bank_name) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase()
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                                align: "center",
                                sx: {
                                    marginBottom: 10
                                },
                                children: [
                                    "Số t\xe0i khoản: ",
                                    item === null || item === void 0 ? void 0 : (ref2 = item.bank_configs) === null || ref2 === void 0 ? void 0 : ref2.bank_account_number
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                                align: "center",
                                sx: {
                                    marginBottom: 10
                                },
                                children: "Nội dung chuyển khoản: [SDT] [Khoảng c\xe1ch] [M\xe3 đơn h\xe0ng] [Ghi ch\xfa (nếu c\xf3)]"
                            })
                        ]
                    })
                ]
            }, item === null || item === void 0 ? void 0 : item._id);
        })
    });
};


/***/ }),

/***/ 41291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PageContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72445);





function PageContainer(_param) {
    var children = _param.children, style = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        size: "xl"
    }, style), {
        children: children
    }));
};


/***/ }),

/***/ 93241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Hr": function() { return /* reexport */ SelectComponent; },
  "Gm": function() { return /* reexport */ WhyChooseHome; }
});

// UNUSED EXPORTS: CheckBoxPaymentMethod

// EXTERNAL MODULE: ./common/components/CheckBoxPaymentMethod/CheckBoxPaymentMethod.js
var CheckBoxPaymentMethod = __webpack_require__(74043);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./utils/removeVietnameseAccent.js
function removeVietnameseAccent(str) {
    // Chuyển chuỗi về chữ thường
    str = str.toLowerCase();
    // Loại bỏ các ký tự có dấu
    str = str.replace(/[áàảãạăắằẳẵặâấầẩẫậ]/g, "a");
    str = str.replace(/[éèẻẽẹêếềểễệ]/g, "e");
    str = str.replace(/[óòỏõọôốồổỗộơớờởỡợ]/g, "o");
    str = str.replace(/[íìỉĩị]/g, "i");
    str = str.replace(/[úùủũụưứừửữự]/g, "u");
    str = str.replace(/[ýỳỷỹỵ]/g, "y");
    str = str.replace(/đ/g, "d");
    // Loại bỏ các ký tự khác
    str = str.replace(/[^a-z0-9\s]/gi, "");
    // Loại bỏ khoảng trắng thừa
    str = str.trim().replace(/\s+/g, " ");
    return str;
}
/* harmony default export */ var utils_removeVietnameseAccent = (removeVietnameseAccent);

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Group/Group.js + 2 modules
var Group = __webpack_require__(66137);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Select/Select.js + 11 modules
var Select = __webpack_require__(89072);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./common/components/SelectComponent/index.js







var SelectItem = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var label = _param.label, value = _param.value, others = (0,_object_without_properties/* default */.Z)(_param, [
        "label",
        "value"
    ]);
    console.log("\uD83D\uDE80 ~ file: index.js:5 ~ SelectItem ~ value:", value);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref
    }, others), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
            noWrap: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    size: "sm",
                    children: value
                })
            })
        })
    }));
});
function SelectComponent(param, props) {
    var data = param.data, valueKey = param.valueKey, _labelKey = param.labelKey, labelKey = _labelKey === void 0 ? "" : _labelKey, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, label = param.label, onChange = param.onChange, _autoSelectDefault = param.autoSelectDefault, autoSelectDefault = _autoSelectDefault === void 0 ? false : _autoSelectDefault, valueDefault = param.valueDefault, _required = param.required, required = _required === void 0 ? false : _required, formValidate = param.formValidate, sx = param.sx;
    var ref = (0,react.useState)([
        {
            value: "",
            label: ""
        }, 
    ]), dataSource = ref[0], setDataSource = ref[1];
    var ref1 = (0,react.useState)(""), value = ref1[0], setValue = ref1[1];
    var ref2 = (0,react.useState)(""), searchValue = ref2[0], setSearchValue = ref2[1];
    (0,react.useEffect)(function() {
        if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
            var newList = data === null || data === void 0 ? void 0 : data.map(function(item) {
                var newItem = (0,_object_spread/* default */.Z)({}, {
                    value: item[valueKey] ? item[valueKey] : " ",
                    label: item[labelKey] ? item[labelKey] : " ",
                    valueShow: item[labelKey] ? item[labelKey] : " "
                });
                return newItem;
            });
            setDataSource(newList);
        }
    }, [
        data,
        labelKey,
        valueKey
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (!valueDefault) {
            setValue(valueDefault);
        }
        if (valueDefault && (dataSource === null || dataSource === void 0 ? void 0 : dataSource.length) > 0 && ((ref = dataSource[0]) === null || ref === void 0 ? void 0 : ref.value) !== "") {
            var item = dataSource.find(function(e) {
                return valueDefault === (e === null || e === void 0 ? void 0 : e.value);
            });
            if (!item) {
                item = {
                    value: "",
                    label: ""
                };
            }
            setValue(item === null || item === void 0 ? void 0 : item.value);
            if (typeof onChange === "function") {
                onChange(item === null || item === void 0 ? void 0 : item.value);
            }
            return;
        }
        if (autoSelectDefault && (dataSource === null || dataSource === void 0 ? void 0 : dataSource.length) > 0) {
            var ref1;
            setValue((ref1 = dataSource[0]) === null || ref1 === void 0 ? void 0 : ref1.value);
            if (typeof onChange === "function") {
                var ref2;
                onChange((ref2 = dataSource[0]) === null || ref2 === void 0 ? void 0 : ref2.value);
            }
        }
    }, [
        dataSource,
        valueDefault
    ]);
    var onChangeValue = function(value) {
        setValue(value);
        if (typeof onChange === "function") {
            onChange(value);
        }
    };
    // useEffect(() => {
    //   if (searchValue) {
    //     const newList = data?.map((item) => {
    //       const newItem = {
    //         ...{
    //           value: item[valueKey] ? item[valueKey] : " ",
    //           label: item[labelKey] ? item[labelKey] : " ",
    //         },
    //       };
    //       return newItem;
    //     });
    //     const newDataSource = newList.filter((item) => {
    //       const itemValue = removeVietnameseAccent(item?.value);
    //       return itemValue.includes(searchValue?.toLowerCase());
    //     });
    //     setDataSource(newDataSource);
    //   }
    // }, [searchValue]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.Ph, (0,_object_spread/* default */.Z)({
        withAsterisk: required,
        value: value,
        label: label,
        searchValue: searchValue,
        onSearchChange: setSearchValue,
        filter: function(searchValue, item) {
            return utils_removeVietnameseAccent(item === null || item === void 0 ? void 0 : item.value).toLowerCase().includes(searchValue === null || searchValue === void 0 ? void 0 : searchValue.toLowerCase()) || utils_removeVietnameseAccent(item === null || item === void 0 ? void 0 : item.label).toLowerCase().includes(searchValue === null || searchValue === void 0 ? void 0 : searchValue.toLowerCase());
        },
        placeholder: placeholder,
        itemComponent: SelectItem,
        data: dataSource,
        searchable: true,
        maxDropdownHeight: 300,
        nothingFound: "Kh\xf4ng t\xecm thấy",
        onChange: onChangeValue,
        sx: (0,_object_spread/* default */.Z)({}, sx)
    }, props, formValidate));
};
SelectItem.displayName = "SelectItem";

// EXTERNAL MODULE: ./common/components/PageContainer.js
var PageContainer = __webpack_require__(41291);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(62679);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(19236);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./common/Typography/TitleCus.js
var TitleCus = __webpack_require__(95197);
// EXTERNAL MODULE: ./setup/locale-provider/index.js
var locale_provider = __webpack_require__(59963);
// EXTERNAL MODULE: ./utils/sanitizeDOMData.js + 1 modules
var sanitizeDOMData = __webpack_require__(2559);
// EXTERNAL MODULE: ./utils/appendImageUrlFromAPI.js
var appendImageUrlFromAPI = __webpack_require__(22312);
;// CONCATENATED MODULE: ./common/components/WhyChooseHome.js








function WhyChooseHome(param) {
    var item = param.item, isHomeScreen = param.isHomeScreen;
    var transformLink = function transformLink(picture) {
        var link = picture || null;
        if (link != null) {
            if (link && link.indexOf("http") < 0) {
                link = "".concat("https://api.flexzen.app").concat(link, "?access_token=").concat("flex.public.token", "&trustkey=").concat("APP.FKJSHHHH908KJF");
            }
        }
        return link;
    };
    var ref, ref1;
    var getLabel = (0,locale_provider/* useLocalContext */.u)().getLabel;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        component: "section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
            sx: {
                paddingBottom: isHomeScreen ? 0 : 80
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleCus/* default */.Z, {
                    children: item && getLabel((0,sanitizeDOMData/* default */.Z)((ref = item[3]) === null || ref === void 0 ? void 0 : ref.title))
                }),
                !isHomeScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: transformLink((ref1 = item[0]) === null || ref1 === void 0 ? void 0 : ref1.picture),
                        layout: "responsive",
                        height: "435px",
                        width: "963px",
                        objectFit: "cover"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    component: "section",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid */.r, {
                        children: Boolean(item) && item.map(function(item, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: index >= 0 && index <= 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid.Col */.r.Col, {
                                    sm: 4,
                                    sx: {
                                        padding: 25
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (0,appendImageUrlFromAPI/* default */.Z)({
                                                src: item === null || item === void 0 ? void 0 : item.picture,
                                                size: "l"
                                            }),
                                            layout: "responsive",
                                            height: "192px",
                                            width: "274px",
                                            objectFit: "cover"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                                            order: 4,
                                            align: "center",
                                            sx: function(theme) {
                                                return {
                                                    paddingBottom: 15,
                                                    paddingTop: 15,
                                                    color: theme.colors.main[5]
                                                };
                                            },
                                            children: getLabel(item.title)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            size: 18,
                                            style: {
                                                paddingTop: 10,
                                                lineHeight: "35px"
                                            },
                                            align: "justify",
                                            children: (item === null || item === void 0 ? void 0 : item.content) && getLabel((0,sanitizeDOMData/* default */.Z)(item === null || item === void 0 ? void 0 : item.content))
                                        })
                                    ]
                                })
                            });
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./common/components/index.js






/***/ })

}]);